import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../components/Seo";
import { adminLogin } from "../lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await adminLogin(email.trim(), password);
            navigate("/admin/dashboard", { replace: true });
        } catch (e) {
            const detail = e?.response?.data?.detail;
            setErr(typeof detail === "string" ? detail : "Login failed. Try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <main data-testid="page-admin-login" className="min-h-[100svh] bg-[#F9F8F6] flex items-center justify-center px-6">
            <Seo path="/admin/login" title="Admin · Sign in" noindex />
            <form onSubmit={onSubmit} className="w-full max-w-md">
                <p className="asc-overline">Studio Administration</p>
                <h1 className="serif text-4xl lg:text-5xl mt-4 leading-[1.05] tracking-tight font-light">
                    Sign in.
                </h1>
                <p className="mt-3 text-[#5C5855] text-sm">Protected area — inquiry management.</p>

                <div className="mt-12 space-y-8">
                    <div>
                        <label className="asc-overline">Email</label>
                        <input
                            type="email"
                            data-testid="admin-email-input"
                            className="asc-input mt-2"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            autoComplete="email"
                            required
                        />
                    </div>
                    <div>
                        <label className="asc-overline">Password</label>
                        <input
                            type="password"
                            data-testid="admin-password-input"
                            className="asc-input mt-2"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"
                            required
                        />
                    </div>
                </div>

                {err && (
                    <p data-testid="admin-login-error" className="mt-8 text-sm text-red-700">
                        {err}
                    </p>
                )}

                <button
                    type="submit"
                    data-testid="admin-login-submit"
                    disabled={loading}
                    className="mt-12 inline-flex items-center px-9 py-4 bg-[#1A1A1A] text-[#F9F8F6] text-[11px] uppercase tracking-[0.24em] hover:bg-[#3E3A37] disabled:opacity-60 transition-colors"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </button>
            </form>
        </main>
    );
}
